import { Requirement } from '../models';


/**
 * Returns the number of invited raters in the list of maybe requirements.
 * No requirements -> 0
 */
export const countInvited = (
  requirements: Requirement[] | undefined,
): number => (requirements || []).reduce((running, next) => running + next.invitedCount, 0);


/**
 * Returns the number of incomplete surveys in the list of maybe requirements.
 * No requirements -> 0
 */
export const countIncomplete = (
  requirements: Requirement[] | undefined,
): number => (requirements || []).reduce((running, next) => running + next.invitedCount - next.completedCount, 0);
